import { render } from "./App.vue?vue&type=template&id=4f798a69"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4f798a69&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/LiveABC-qrcode/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__